import { render, staticRenderFns } from "./PopinPrint.vue?vue&type=template&id=54ed1f8c&scoped=true&"
import script from "./PopinPrint.vue?vue&type=script&lang=js&"
export * from "./PopinPrint.vue?vue&type=script&lang=js&"
import style0 from "./PopinPrint.vue?vue&type=style&index=0&id=54ed1f8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed1f8c",
  null
  
)

export default component.exports